<template>
  <div class="d-flex flex-column col-md-12 mt-5 mb-3">
    <div class="text-title mt-5">Email: <a :href = "'mailto:' + mEmail">{{mEmail}}</a></div>
    <div class="text-title">&copy; {{mText}} All Rights Reserved.</div>
  </div>
</template>

<script>
export default {
  name: 'RowQuote',
  data () {
    return {
      mEmail: 'info@bettersense.io',
      mText: '2019 by BetterSense'
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .l-debug {
    border-width: 1px;
    border-color: yellow;
    border-style: dashed;
  }
  h1, h2 {
    font-weight: normal;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
  .text-title {
    display: inline-block;
    font-weight: normal;
    font-size: small;
  }

</style>



// WEBPACK FOOTER //
// src/components/RowFooter.vue